import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases as mdiAliases, mdi } from 'vuetify/iconsets/mdi';
import colors from 'vuetify/util/colors';

const aliases = {
  ...mdiAliases,
  success: 'mdi-check-circle',
  info: 'mdi-information',
  warning: 'mdi-exclamation',
  error: 'mdi-alert',
};

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
  defaults: {
    VTextField: { variant: 'underlined' },
    VSelect: { variant: 'underlined' },
    VBtn: { rounded: 'sm' },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          'default-content': colors.shades.black,
          'default-panel': colors.shades.white,
          background: colors.grey.lighten5,
          primary: colors.blue.darken2,
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FB8C00',
        },
      },
      dark: {
        dark: true,
        colors: {
          'default-content': colors.shades.white,
          'default-panel': '#1e1e1e',
          background: colors.grey.darken4,
          primary: colors.blue.lighten1,
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FB8C00',
        },
      },
    },
  },
});
